<template>
  <section>
    <div v-if="!showPerformancePdf" class="container box mt-5">
      <h1
        v-if="
          performanceInfo.phase && performanceInfo.phase.phase_d_type_id === 1
        "
        class="title"
      >
        Detalle Compromisos de Desempeño del Académico
        <hr class="dropdown-divider" aria-role="menuitem" />
      </h1>

      <h1 v-else class="title">
        Detalle Convenio de Desempeño del Académico
        <hr class="dropdown-divider" aria-role="menuitem" />
      </h1>

      <div
        v-if="
          academic_performances.state === 'ACEPTADA' ||
          (performanceInfo.phase && performanceInfo.phase.phase_d_type_id === 2)
        "
      >
        <div class="columns is-centered">
          <div class="column is-10">
            <b-message has-icon type="is-success">
              El compromiso del convenio de desempeño ya ha sido aceptado por
              el/la Director/a del departamento.
            </b-message>
          </div>
        </div>
        <div
          v-if="
            performanceInfo.phase &&
            performanceInfo.phase.phase_d_type_id === 2 &&
            performanceInfo.is_active_phase_to_declare
          "
          class="columns is-centered"
        >
          <div class="column is-10">
            <b-message has-icon type="is-info">
              Recuerde que se encuentra activo el proceso para declarar las
              horas realizadas, donde podrá además adjuntar las evidencias de
              las actividades realizadas.
            </b-message>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-right">
            <b-button
              v-if="
                performanceInfo.phase &&
                performanceInfo.phase.phase_d_type_id === 2 &&
                performanceInfo.is_active_phase_to_declare
              "
              :label="`Declarar horas realizadas`"
              icon-left="edit"
              type="is-warning"
              tag="a"
              href="/performances/declare-hours"
            />
            <b-button
              :label="`Descargar compromiso`"
              icon-left="download"
              type="is-info"
              @click="downloadPDF"
            />
          </div>
        </div>
      </div>

      <div v-else>
        <div
          v-if="
            performanceInfo.is_active_phase_to_declare === false &&
            academic_performances.state !== 'ACEPTADA' &&
            performanceInfo.is_extend_phase_term === false
          "
        >
          <div class="columns is-centered">
            <div class="column is-10">
              <b-message has-icon type="is-danger">
                Su compromiso del convenio de desempeño no finalizó en el
                periodo correspondiente. Último estado:
                <b>{{ academic_performances.state }}</b>
              </b-message>
            </div>
          </div>
        </div>
        <div
          v-if="
            performanceInfo.is_active_phase_to_declare === false &&
            academic_performances.state !== 'ACEPTADA' &&
            performanceInfo.is_extend_phase_term
          "
        >
          <div class="columns is-centered">
            <div class="column is-10">
              <b-message
                type="is-info"
                has-icon
                title="Importante"
                aria-close-label="Close message"
              >
                Se encuentra en una fase de extensión de plazo para declarar sus
                compromisos de desempeño. Por favor, complete la información
                requerida antes de que finalice el proceso.
              </b-message>
            </div>
          </div>
        </div>
        <div
          v-if="
            (performanceInfo.is_active_phase_to_declare ||
              performanceInfo.is_extend_phase_term) &&
            !showAcademicInfo &&
            academic_performances.state !== 'EMITIDA'
          "
          class="columns is-centered"
        >
          <div class="column has-text-centered">
            <b-button
              v-if="academic_performances.state === 'DEVUELTA'"
              label="Emitir Compromisos Rectificado"
              type="is-success"
              icon-left="check"
              @click="calculateMinialHours"
            />
            <!--              @click="showPerformancePdf = true"-->

            <b-button
              v-else
              label="Emitir Compromisos"
              type="is-success"
              icon-left="check"
              @click="calculateMinialHours"
            />
            <!--              @click="showPerformancePdf = true"-->
          </div>
        </div>

        <div
          v-if="academic_performances.state === 'EMITIDA' && !isDirector"
          class="columns is-centered"
        >
          <div class="column has-text-centered">
            <b-button
              v-if="academic_performances.state === 'ACEPTADA'"
              label="ACEPTADA"
              type="is-success"
              icon-left="check"
              disabled
            />
            <b-button
              v-else
              label="EMITIDA"
              type="is-success"
              icon-left="check"
              disabled
            />
          </div>
        </div>

        <div class="columns">
          <div class="column has-text-right">
            <b-button
              v-if="
                (performanceInfo.is_active_phase_to_declare ||
                  performanceInfo.is_extend_phase_term) &&
                !showAcademicInfo &&
                academic_performances.state !== 'EMITIDA' &&
                performanceInfo.phase &&
                performanceInfo.phase.phase_d_type_id !== 2
              "
              :label="`Editar Compromisos`"
              icon-left="edit"
              type="is-warning"
              tag="a"
              href="/performances/declare"
            />
            <b-button
              v-if="academic_performances.state == 'EMITIDA'"
              :label="`Descargar compromiso`"
              icon-left="download"
              type="is-info"
              @click="downloadPDF"
            />
          </div>
        </div>

        <div
          v-if="academic_performances.state === 'DEVUELTA'"
          class="columns is-centered"
        >
          <div class="column is-10 is-centered">
            <b-message
              type="is-warning"
              has-icon
              title="Importante"
              aria-close-label="Close message"
            >
              Este compromiso de convenio de desempeño fue devuelto por el/la
              Director/a de departamento, con la siguiente observación:<br />
              <b
                ><span class="preserve-line-breaks">
                  {{ academic_performances.comment }}</span
                >
              </b>
            </b-message>
          </div>
        </div>
      </div>

      <div
        v-if="
          academicInfo !== undefined &&
          academicInfo != null &&
          academicInfo.person !== undefined &&
          academicInfo.person != null
        "
      >
        <br />
        <div class="columns is-centered">
          <div class="column is-10 is-centered is-bordered-grey">
            <div class="columns">
              <div class="column is-narrow">
                <p>
                  <b> Nombre: </b>
                  {{
                    academicInfo.person.name +
                    " " +
                    academicInfo.person.last_name +
                    " " +
                    academicInfo.person.second_surname
                  }}
                </p>
              </div>

              <div class="column">
                <p>
                  <b>RUT:</b>
                  {{ academicInfo.person.rut }}
                </p>
              </div>
            </div>

            <div class="columns">
              <div class="column is-narrow">
                <p>
                  <b>Departamento: </b>
                  {{
                    academicInfo.unit_assigned +
                    ` (CC ${academicInfo.unit_assigned_cost_center})`
                  }}
                </p>
              </div>

              <div class="column is-narrow">
                <p>
                  <b>Jerarquía: </b>
                  {{ academicInfo.hierarchy_name }}
                </p>
              </div>

              <div class="column">
                <p>
                  <b>Jornada: </b>
                  {{
                    academicInfo.working_day_name
                      ? academicInfo.working_day_name
                      : "No definida"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />
      </div>

      <div
        v-if="
          performanceInfo.phase && performanceInfo.phase.phase_d_type_id === 1
        "
        class="columns is-centered mb-6"
      >
        <div class="column is-10 is-bordered-grey">
          <AcademicConsolidated
            :academic_areas="academic_areas"
            :performances="academic_performances.activity_performances"
          />
        </div>
      </div>

      <div v-else class="columns is-centered mb-6">
        <div class="column is-10 is-bordered-grey">
          <ConsolidatedFinal
            :academic_areas="academic_areas"
            :performances="academic_performances.activity_performances"
          />
        </div>
      </div>

      <div class="columns is-centered" v-if="isRejecting">
        <div class="column is-10">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickRejectPerformances)">
              <b-field label="Ingrese motivo de devolución*">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-input
                    v-model="rejectComment"
                    type="textarea"
                    placeholder="Ingrese motivo de la devolución de este compromiso de desempeño"
                  />
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>

              <div class="level-right buttons">
                <b-button
                  type="is-primary is-light"
                  icon-left="arrow-left"
                  @click="isRejecting = false"
                >
                  Cancelar devolución
                </b-button>
                <b-button
                  type="is-danger"
                  icon-left="times"
                  :disabled="!rejectComment"
                  native-type="submit"
                >
                  Devolver compromiso de desempeño
                </b-button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>

      <div
        class="columns"
        v-if="
          academic_performances.state === 'EMITIDA' &&
          isDirector &&
          !isRejecting
        "
      >
        <div class="column has-text-right px-1">
          <b-button
            type="is-danger"
            icon-left="times"
            @click="isRejecting = true"
          >
            Devolver compromisos
          </b-button>
        </div>
        <div class="column has-text-left px-1">
          <b-button
            type="is-success"
            icon-left="check"
            @click="onClickAcceptPerformances"
          >
            Aceptar compromisos
          </b-button>
        </div>
      </div>

      <b-tabs position="is-centered">
        <b-tab-item label="Todos">
          <div class="columns">
            <div class="column has-text-right">
              <b-button
                :label="isOpen ? 'Contraer Áreas' : 'Expandir Áreas'"
                :icon-left="isOpen ? 'minus-circle' : 'plus-circle'"
                type="is-blue-color"
                @click="isOpen = !isOpen"
              />
            </div>
          </div>
          <div
            v-if="
              performanceInfo.phase &&
              performanceInfo.phase.phase_d_type_id === 1
            "
          >
            <AreaCommitmentsCollapse
              class="my-2"
              v-for="area in academic_areas"
              :academicArea="area"
              :isOpen="isOpen"
              :subjects="subjects"
              :performances="
                academic_performances.activity_performances.filter(
                  (x) => x.alt_name_area === area.alt_name
                )
              "
            />
          </div>
          <div v-else>
            <AreaCompletedCollapse
              class="my-2"
              :subjectsSemester1="my_real_hours_subjects_semester_1"
              :subjectsSemester2="my_real_hours_subjects_semester_2"
              v-for="area in academic_areas"
              :academicArea="area"
              :isOpen="isOpen"
              :subjects="subjects"
              :performances="
                academic_performances.activity_performances.filter(
                  (x) => x.alt_name_area === area.alt_name
                )
              "
            />
          </div>
        </b-tab-item>
        <b-tab-item
          v-for="(academic_area, index) in academic_areas"
          :key="index"
          :label="academic_area.alt_name"
        >
          <div
            v-if="
              performanceInfo.phase &&
              performanceInfo.phase.phase_d_type_id === 1
            "
          >
            <ShowTableCommitmentComponent
              :performances="academic_performances.activity_performances"
              :academicArea="academic_area"
              :subjects="subjects"
            />
          </div>
          <div v-else>
            <ShowTableCompletedComponent
              :performances="academic_performances.activity_performances"
              :academicArea="academic_area"
              :subjects="subjects"
            />
          </div>
        </b-tab-item>
      </b-tabs>
    </div>

    <div v-else class="container box mt-5">
      <DownloadAcademicPerformances
        :academicPerformances="academic_performances"
        :academicAreas="academic_areas"
        :email="academicInfo.person.corporate_mail"
        :subjects="subjects"
        @close="showPerformancePdf = false"
      />
    </div>

    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    <b-modal
      v-model="isModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      :can-cancel="canCancel"
    >
      <template #default="props">
        <Modal-verification-code
          :email="personEmail"
          :performance-id="academic_performances.id"
          :person-id="personUserId"
          rol="DIRECTOR DEPTO"
          @close="props.close"
        ></Modal-verification-code>
      </template>
    </b-modal>
  </section>
</template>

<script>
import axios from "axios";
import AcademicConsolidated from "./AcademicConsolidated.vue";
import ShowTableCommitmentComponent from "./ShowTableCommitmentComponent.vue";
import DownloadAcademicPerformances from "./DownloadAcademicPerformances.vue";
import AreaCommitmentsCollapse from "./AreaCommitmentsCollapse.vue";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import pdf from "vue-pdf";
import ModalVerificationCode from "./ModalVerificationCode.vue";
import ConsolidatedFinal from "./ConsolidatedFinal.vue";
import ShowTableCompletedComponent from "./ShowTableCompletedComponent.vue";
import AreaCompletedCollapse from "./AreaCompletedCollapse.vue";
export default {
  name: "ShowPerformance",

  props: {
    year: {
      type: Number,
      required: true,
    },
    personId: {
      type: Number,
      required: true,
    },

    showAcademicInfo: {
      type: Boolean,
      required: true,
    },
    isDirector: {
      type: Boolean,
      required: false,
      default: false,
    },
    personUserId: {
      type: Number,
      required: true,
    },
    personEmail: {
      type: String,
      require: true,
    },
  },

  components: {
    AcademicConsolidated,
    ShowTableCommitmentComponent,
    DownloadAcademicPerformances,
    AreaCommitmentsCollapse,
    ModalVerificationCode,
    ConsolidatedFinal,
    ShowTableCompletedComponent,
    AreaCompletedCollapse,
  },

  data() {
    return {
      //Auxiliares
      isLoading: false,
      infoLoad: false,
      openedDetail: [],
      showPerformancePdf: false,
      isOpen: false,

      //Datos a traer
      academic_areas: [],
      academic_performances: {
        activity_performances: [],
      },
      performanceInfo: {},
      academicInfo: {},
      isRejecting: false,
      rejectComment: null,
      data: [],
      isModalActive: false,
      canCancel: false,
      subjects: [],
      my_real_hours_subjects_semester_1: [],
      my_real_hours_subjects_semester_2: [],
    };
  },

  async created() {
    await this.getAcademicAreas();
    await this.getPerformances();
    await this.getPerformanceInfoForAcademic();
    await this.calculateConsolidated();
    await this.getAcademicInfo();
    await this.getSubjects();
    await this.getMyRealHoursSubjects();
  },

  methods: {
    openModalVerificationCode() {
      this.isLoading = true;
      axios
        .post("/verification_codes.json", {
          email: this.personEmail,
        })
        .then((res) => {
          this.isModalActive = true;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al enviar el código de verificación. Intentelo nuevamente.",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.isLoading = false;
        });
    },

    onClickRejectPerformances() {
      this.$buefy.dialog.confirm({
        title: "¿Desea devolver este compromiso?",
        message: `Esta acción provocará que el/la académico/a <b>${this.academicInfo.person.name} ${this.academicInfo.person.last_name} ${this.academicInfo.person.second_surname}</b>
                        deba corregir su compromiso de desempeño según el motivo de devolución ingresado.<br>
                        Motivo de la devolución: <b>${this.rejectComment}</b>`,
        confirmText: "Devolver",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.postRejectPerformances();
        },
      });
    },
    onClickAcceptPerformances() {
      this.$buefy.dialog.confirm({
        title: "¿Desea aceptar este compromiso?",
        message:
          "Esta acción requerirá que valides el compromiso de desempeño, y una vez validado, este quedará marcado como aceptado y no podrá ser modificado.",
        confirmText: "Aceptar",
        cancelText: "Cancelar",
        type: "is-success",
        hasIcon: true,
        onConfirm: () => {
          this.openModalVerificationCode();
        },
      });
    },
    postAcceptPerfromances() {
      this.isLoading = true;
      axios
        .post(
          `/performances/${this.academic_performances.id}/sign-principals.json`,
          {
            person_id: this.personUserId,
          }
        )
        .then((response) => {
          this.goToSas(response.data);
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al aceptar el compromiso. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    postRejectPerformances() {
      this.isLoading = true;
      axios
        .post("/performances/stop-process-performance.json", {
          id: this.academic_performances.id,
          comment: this.rejectComment,
        })
        .then(() => {
          this.$buefy.dialog.alert({
            title: "¡Éxito!",
            message:
              "El compromiso de desempeño ha sido devuelto exitosamente.",
            type: "is-success",
            hasIcon: true,
            confirmText: "Ok",
            onConfirm: () => {
              location.reload();
            },
          });
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al devolver el compromiso. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async goToSas(data) {
      window.location.href = `${data.url}?email=${data.email}`;
    },

    async getSubjects() {
      this.isLoading = true;
      axios
        .get("/performances/sai-subjects.json")
        .then((response) => {
          this.subjects = response.data;
          this.subjects.push({
            codigo: -1,
            electividad: -1,
            electivo: "N",
            nombre: "OTROS",
            sct: -1,
            tel: "0-0-0",
            tipo: "",
            titulacion: "",
            alt_nombre: "Otros",
            codigo_nombre: "OTROS",
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getAcademicAreas() {
      this.isLoading = true;
      await axios
        .get("/academic_areas.json")
        .then((response) => {
          this.academic_areas = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getPerformances() {
      this.isLoading = true;
      await axios
        .get(`/performances/process/${this.year}/person/${this.personId}.json`)
        .then((response) => {
          this.academic_performances = response.data;

          let index = 1;
          this.academic_performances.activity_performances.forEach(
            (performance) => {
              performance.commitment_index = index;
              index++;
            }
          );
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getPerformanceInfoForAcademic() {
      this.isLoading = true;
      await axios
        .get("/performances/get-performance-info-for-academic.json", {
          params: {
            person_id: this.personId,
          },
        })
        .then(async (response) => {
          this.performanceInfo = response.data;
          this.performanceInfo.phase.start_date = moment(
            this.performanceInfo.phase.start_date,
            ["YYYY-MM-DD", "DD-MM-YYYY"]
          );
          this.performanceInfo.phase.end_date = moment(
            this.performanceInfo.phase.end_date,
            ["YYYY-MM-DD", "DD-MM-YYYY"]
          );
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getAcademicInfo() {
      this.isLoading = true;
      await axios
        .get(`/people/${this.personId}/my-all-academic-data.json`)
        .then((response) => {
          this.academicInfo = response.data;
          this.infoLoad = true;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    calculateConsolidated() {
      this.isLoading = true;

      this.data = this.academic_areas.map((area) => {
        return {
          academic_area_id: area.id,
          area: area.alt_name,
          hours_committed_weekly: 0.0,
          hours_committed_yearly: 0.0,
          hours_committed_weekly_1: 0.0,
          hours_committed_yearly_1: 0.0,
          hours_committed_weekly_2: 0.0,
          hours_committed_yearly_2: 0.0,
          percentage: 0.0,
        };
      });

      this.academic_performances.activity_performances.forEach(
        (performance) => {
          let area = this.data.find(
            (area) => area.academic_area_id === performance.academic_area_id
          );
          let area_index = this.data.findIndex(
            (area) => area.academic_area_id === performance.academic_area_id
          );
          if (area) {
            if (performance.is_weekly_hours) {
              area.hours_committed_weekly_1 += parseFloat(
                performance.hours_committed_semester_1
              );
              area.hours_committed_weekly_2 += parseFloat(
                performance.hours_committed_semester_2
              );
            } else {
              area.hours_committed_yearly_1 += parseFloat(
                performance.hours_committed_semester_1
              );
              area.hours_committed_yearly_2 += parseFloat(
                performance.hours_committed_semester_2
              );
            }
            this.data[area_index] = area;
          }
        }
      );

      let total = 0.0;

      this.data.forEach((area) => {
        area.hours_committed_weekly = parseFloat(
          (
            (area.hours_committed_weekly_1 + area.hours_committed_weekly_2) /
            2
          ).toFixed(1)
        );
        area.hours_committed_yearly = parseFloat(
          (
            area.hours_committed_yearly_1 + area.hours_committed_yearly_2
          ).toFixed(1)
        );
        total += area.hours_committed_weekly * 36 + area.hours_committed_yearly;
      });

      this.hours_weekly = parseFloat(
        this.data
          .reduce((acc, area) => acc + area.hours_committed_weekly, 0.0)
          .toFixed(1)
      );
      this.hours_yearly = parseFloat(
        this.data
          .reduce((acc, area) => acc + area.hours_committed_yearly, 0.0)
          .toFixed(1)
      );

      this.hours_eq = parseFloat(
        ((this.hours_weekly * 36 + this.hours_yearly) / 44).toFixed(1)
      );
      this.isLoading = false;
    },
    async downloadPDF() {
      this.isLoading = true;
      let width = 216; // 8.5 pulgadas en mm
      let height = 356; // 14 pulgadas en mm
      let doc = new jsPDF({
        orientation: "landscape",
        format: [width, height],
      });
      // Dimensiones de la página
      let pageWidth = doc.internal.pageSize.width;

      // HEADER
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      let header = [
        "UNIVERSIDAD DE SANTIAGO DE CHILE",
        "FACULTAD DE INGENIERÍA",
        this.academicInfo.unit_assigned.toUpperCase(),
      ];
      doc.text(header, 10, 15);

      // TITLE
      let blockTitlePosition = 25;
      doc.setFontSize(12);

      let title = "DECLARACIÓN DE COMPROMISOS DE DESEMPEÑO";
      let titleWidth = doc.getTextWidth(title);
      let titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, blockTitlePosition);

      blockTitlePosition += 6;
      title = "ACADÉMICOS CUERPO REGULAR";
      titleWidth = doc.getTextWidth(title);
      titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, blockTitlePosition);

      blockTitlePosition += 6;
      title = `AÑO ${this.academic_performances.year}`;
      titleWidth = doc.getTextWidth(title);
      titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, blockTitlePosition);

      // Configuration for all tables performances
      let tableMargin = 12;
      let tableWidth = pageWidth - tableMargin * 2;
      let marginLeft = (pageWidth - tableWidth) / 2;

      // ACADEMIC INFORMATION
      let blockAcademicInformationPosition = blockTitlePosition + 3;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text(
        "I. Antecedentes Personales",
        11,
        blockAcademicInformationPosition
      );

      let columns = [
        this.academicInfo.person.last_name,
        this.academicInfo.person.second_surname,
        this.academicInfo.person.name,
      ];
      let rows = [["Primer Apellido", "Segundo Apellido", "Nombres"]];

      blockAcademicInformationPosition += 5;
      doc.autoTable({
        head: [columns],
        body: rows,
        startY: blockAcademicInformationPosition,
        theme: "plain",
        margin: { left: marginLeft },
        columnStyles: {
          0: { cellWidth: tableWidth * 0.33 },
          1: { cellWidth: tableWidth * 0.33 },
          2: { cellWidth: tableWidth * 0.33 },
        },
        styles: {
          fontSize: 8,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "center",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 8,
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "center",
        },
      });

      columns = [
        this.academicInfo.faculty_assigned,
        this.academicInfo.unit_assigned,
        this.academicInfo.hierarchy_name,
        this.academicInfo.working_day_name,
      ];
      rows = [["Facultad", "Departamento", "Jerarquía", "Jornada"]];

      blockAcademicInformationPosition += 15;
      doc.autoTable({
        head: [columns],
        body: rows,
        startY: blockAcademicInformationPosition,
        theme: "plain",
        margin: { left: marginLeft },
        columnStyles: {
          0: { cellWidth: tableWidth * 0.25 },
          1: { cellWidth: tableWidth * 0.25 },
          2: { cellWidth: tableWidth * 0.25 },
          3: { cellWidth: tableWidth * 0.25 },
        },
        styles: {
          fontSize: 8,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "center",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 8,
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "center",
        },
      });

      let blockAcademicPerformancePosition =
        blockAcademicInformationPosition + 18;

      columns = [
        "Áreas Académicas",
        "Horas/Semana Comprometidas",
        "Horas/Año Comprometidas",
      ];
      rows = this.data.map((area) => {
        return [
          area.area,
          String(area.hours_committed_weekly),
          String(area.hours_committed_yearly),
        ];
      });

      doc.autoTable({
        head: [columns],
        body: rows,
        startY: blockAcademicPerformancePosition,
        theme: "grid",
        margin: { left: marginLeft },
        columnStyles: {
          0: { cellWidth: tableWidth * 0.4 },
          1: { cellWidth: tableWidth * 0.3 },
          2: { cellWidth: tableWidth * 0.3 },
        },
        styles: {
          fontSize: 8,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "left",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: 200,
          lineWidth: 0.25,
          fontSize: 8,
          fontStyle: "bold",
          halign: "left",
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "left",
        },
      });

      columns = ["", "Semanales", "Anuales"];
      rows = [
        [
          "Horas Cronológicas Promedio Anual",
          String(this.hours_weekly),
          String(this.hours_yearly),
        ],
        [
          "Horas Semanales Equivalentes Totales",
          {
            content: String(this.hours_eq),
            colSpan: 2,
            styles: { halign: "center" },
          },
        ],
      ];

      blockAcademicPerformancePosition += 56;
      doc.autoTable({
        head: [columns],
        body: rows,
        startY: blockAcademicPerformancePosition,
        theme: "grid",
        margin: { left: marginLeft },
        columnStyles: {
          0: { cellWidth: tableWidth * 0.4 },
          1: { cellWidth: tableWidth * 0.3 },
          2: { cellWidth: tableWidth * 0.3 },
        },
        styles: {
          fontSize: 8,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "left",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: 200,
          lineWidth: 0.25,
          fontSize: 8,
          fontStyle: "bold",
          halign: "left",
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "left",
        },
      });

      //SIGANTURES
      let blockSignaturesPosition = blockAcademicPerformancePosition + 48;

      let lineLength = 80; // Length of the line
      let lineSpacing = 30; // Spacing between lines
      let textOffset = 5;

      // First line for signatures
      let firstLineX1 = pageWidth / 2 - lineLength - lineSpacing / 2;
      let firstLineX2 = firstLineX1 + lineLength;
      let text1X = firstLineX1 + lineLength / 2;
      let text1Y = blockSignaturesPosition + textOffset;
      let academicCharge = "";

      //SE AGREGA VALIDACIÓN DE CÓDIGO COMO FIRMA DEL ACADEMICO
      if (this.academic_performances.data_verification_code_academic) {
        doc.setFont("helvetica", "normal");
        doc.text(
          `AUTORIZADO POR CÓDIGO DE VERIFICACIÓN`,
          firstLineX1,
          text1Y - 18
        );
        doc.text(
          `NOMBRE: ${this.academic_performances.data_verification_code_academic.nombre}`,
          firstLineX1,
          text1Y - 13
        );
        doc.text(
          `FECHA: ${this.academic_performances.data_verification_code_academic.fecha}`,
          firstLineX1,
          text1Y - 8
        );
      }

      //PIE DE FIRMA ACADEMICO
      doc.setFont("helvetica", "bold");
      academicCharge = "Académico(a)";
      doc.text(academicCharge, text1X, text1Y, { align: "center" });

      // Second line for signatures
      let secondLineX1 = pageWidth / 2 + lineSpacing / 2;
      let secondLineX2 = secondLineX1 + lineLength;
      let text2X = secondLineX1 + lineLength / 2;
      let text2Y = blockSignaturesPosition + textOffset;
      let directorCharge = "";

      //SE AGREGA VALIDACIÓN DE CÓDIGO COMO FIRMA DEL ACADEMICO
      if (this.academic_performances.data_verification_code_principals) {
        doc.setFont("helvetica", "normal");
        doc.text(
          `AUTORIZADO POR CÓDIGO DE VERIFICACIÓN`,
          secondLineX1,
          text2Y - 18
        );
        doc.text(
          `NOMBRE: ${this.academic_performances.data_verification_code_principals.nombre}`,
          secondLineX1,
          text2Y - 13
        );
        doc.text(
          `FECHA: ${this.academic_performances.data_verification_code_principals.fecha}`,
          secondLineX1,
          text2Y - 8
        );
      }

      //PIE DE FIRMA DIRECTOR
      doc.setFont("helvetica", "bold");
      directorCharge = "Director(a) de Departamento";
      doc.text(directorCharge, text2X, text2Y, { align: "center" });

      doc.line(
        firstLineX1,
        blockSignaturesPosition,
        firstLineX2,
        blockSignaturesPosition
      ); // First line
      doc.line(
        secondLineX1,
        blockSignaturesPosition,
        secondLineX2,
        blockSignaturesPosition
      ); // Second Line

      // TABLES Performances
      let tableConfig = {
        startY: 20,
        theme: "grid",
        margin: { left: marginLeft },
        columnStyles: {
          0: { cellWidth: tableWidth * 0.3 },
          1: { cellWidth: tableWidth * 0.1 },
          2: { cellWidth: tableWidth * 0.1 },
          3: { cellWidth: tableWidth * 0.1 },
          4: { cellWidth: tableWidth * 0.1 },
          5: { cellWidth: tableWidth * 0.3 },
        },
        styles: {
          fontSize: 8,
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          halign: "left",
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          lineColor: 200,
          lineWidth: 0.25,
          fontSize: 8,
          fontStyle: "bold",
          halign: "left",
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "left",
        },
      };

      this.academic_areas.forEach((area, index) => {
        doc.addPage();
        if (index === 0) {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(10);
          doc.text("II. Descripción compromisos", 11, 15);
        }

        let total_hours_1_weekly = 0.0;
        let total_hours_2_weekly = 0.0;
        let total_hours_1_semiannually = 0.0;
        let total_hours_2_semiannually = 0.0;
        rows = this.academic_performances.activity_performances
          .filter((performance) => performance.academic_area_id === area.id)
          .map((performance) => {
            let activity_name = "";
            if (performance.subject_code) {
              const subject_filter = this.subjects.filter(
                (subject) =>
                  parseInt(performance.subject_code) === subject.codigo
              )[0]?.codigo_nombre;
              activity_name =
                performance.alt_name_activity + " - " + (subject_filter || "");
            } else {
              activity_name = performance.alt_name_activity;
            }
            let hours_committed_semester_1_week = performance.is_weekly_hours
              ? performance.hours_committed_semester_1
              : 0.0;
            let hours_committed_semester_2_week = performance.is_weekly_hours
              ? performance.hours_committed_semester_2
              : 0.0;
            let hours_committed_semester_1_semiannually =
              performance.is_weekly_hours
                ? 0.0
                : performance.hours_committed_semester_1;
            let hours_committed_semester_2_semiannually =
              performance.is_weekly_hours
                ? 0.0
                : performance.hours_committed_semester_2;
            if (performance.is_weekly_hours) {
              total_hours_1_weekly += parseFloat(
                performance.hours_committed_semester_1
              );
              total_hours_2_weekly += parseFloat(
                performance.hours_committed_semester_2
              );
            } else {
              total_hours_1_semiannually += parseFloat(
                performance.hours_committed_semester_1
              );
              total_hours_2_semiannually += parseFloat(
                performance.hours_committed_semester_2
              );
            }
            return [
              activity_name,
              hours_committed_semester_1_week,
              hours_committed_semester_1_semiannually,
              hours_committed_semester_2_week,
              hours_committed_semester_2_semiannually,
              performance.observations,
            ];
          });

        rows.push([
          "TOTAL " + area.name,
          total_hours_1_weekly,
          total_hours_1_semiannually,
          total_hours_2_weekly,
          total_hours_2_semiannually,
          "",
        ]);

        let header = [
          [
            {
              content: "",
              colSpan: 1,
              rowSpan: 2,
              styles: { halign: "center", valign: "middle" },
            },
            {
              content: "Primer Semestre",
              colSpan: 2,
              styles: { halign: "center" },
            },
            {
              content: "Segundo Semestre",
              colSpan: 2,
              styles: { halign: "center" },
            },
            {
              content: "Observaciones",
              colSpan: 1,
              rowSpan: 3,
              styles: { halign: "center", valign: "middle" },
            },
          ],
          [
            {
              content: "Horas Comprometidas",
              colSpan: 2,
              styles: { halign: "center" },
            },
            {
              content: "Horas Comprometidas",
              colSpan: 2,
              styles: { halign: "center" },
            },
          ],
          [area.name, "Semana", "Semestre", "Semana", "Semestre"],
        ];

        doc.autoTable({
          head: header,
          body: rows,
          ...tableConfig,
        });
      });

      // Agregar logo en el lado derecho
      let imgPath = "/logo_negro_facultad_ing.png"; // Ruta del logo en la carpeta public
      let imgWidth = 60; // Ancho de la imagen
      let imgHeight = 0; // Alto de la imagen segun proporciones originales
      let imgX = pageWidth - imgWidth - 10; // Calcula la posición para el lado derecho
      let imgY = 5; // Posición vertical

      const response = await fetch(imgPath);
      const blob = await response.blob();

      // Convertir el Blob en una cadena Base64
      const base64Image = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob); // Convierte el blob en Base64
      });

      // Crear una imagen y cargar el logo
      let img = new Image();
      img.src = imgPath;
      img.onload = () => {
        doc.setPage(1);
        doc.addImage(base64Image, "PNG", imgX, imgY, imgWidth, imgHeight);
        this.pdfBlob = doc.output("blob");
        this.urlPagePdf = URL.createObjectURL(this.pdfBlob);
        const year = this.academic_performances.year;
        const rut = this.academicInfo.person.rut;
        const filename = `COMPRMISO_CONVENIO_DESEMPEÑO_${rut}_${year}.pdf`;
        doc.save(filename);
        this.isLoading = false;
      };
    },
    calculateMinialHours() {
      const docencia_area = this.data.filter(
        (area) => area.area === "Docencia"
      )[0];
      const docencia_weekly = docencia_area.hours_committed_weekly;
      const docencia_yearly = docencia_area.hours_committed_yearly;
      const docencia_eq = parseFloat(
        ((docencia_weekly * 36 + docencia_yearly) / 44).toFixed(1)
      );
      if (this.hours_eq < 36) {
        this.$buefy.dialog.alert({
          title: "Horas insuficientes",
          message:
            "No está cumpliendo con las horas mínimas de actividad académica que son <b>36 horas</b>. Tiene actualmente <b>" +
            this.hours_eq +
            " horas</b>.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      }
      // else if(docencia_eq < 8){
      //   this.$buefy.dialog.alert({
      //     title: "Horas insuficientes",
      //     message:
      //         "No está cumpliendo con las horas mínimas de <b>Docencia</b> que son <b>8 horas</b>. Tiene actualmente <b>" + docencia_eq + " horas</b> equivalentes semanales en docencia.",
      //     type: "is-danger",
      //     hasIcon: true,
      //     icon: "times-circle",
      //     iconPack: "fa",
      //     ariaRole: "alertdialog",
      //     ariaModal: true,
      //   });
      // }
      else {
        this.showPerformancePdf = true;
      }
    },
    async getMyRealHoursSubjects() {
      this.isLoading = true;
      axios
        .get(`/performances/real-hours-subjects/${this.year}.json`)
        .then((response) => {
          this.my_real_hours_subjects_semester_1 = response.data.semestre_1;
          this.my_real_hours_subjects_semester_2 = response.data.semestre_2;
          this.academic_performances.activity_performances.forEach(
            (performance) => {
              if (performance.subject_code) {
                const subject = this.my_real_hours_subjects_semester_1.find(
                  (subj) => subj.codigo === parseInt(performance.subject_code)
                );
                const subject2 = this.my_real_hours_subjects_semester_2.find(
                  (subj) => subj.codigo === parseInt(performance.subject_code)
                );
                if (subject || subject2) {
                  performance.evidences.unshift({
                    id: -1,
                    name: "SAI",
                    alt_name: "Verificación horas por SAI",
                    subject_code: performance.subject_code,
                    created_at: "No Aplica",
                  });
                }
              }
            }
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    showPerformancePdf: async function () {
      if (!this.showPerformancePdf) {
        await this.getAcademicAreas();
        await this.getPerformances();
        await this.getPerformanceInfoForAcademic();
        await this.getAcademicInfo();
      }
    },
    isModalActive: async function () {
      if (!this.isModalActive) {
        await this.getAcademicAreas();
        await this.getPerformances();
        await this.getPerformanceInfoForAcademic();
        await this.getAcademicInfo();
      }
    },
  },
};
</script>

<style scoped>
.preserve-line-breaks {
  white-space: pre-line;
}
</style>
